// import Link from "next/link";
import { NavLink } from "react-router-dom";
import { Text } from "@radix-ui/themes";

interface LinkProps {
  href: string;
}

const MediaLink = ({ href }: LinkProps) => {
  return (
    <div className="bg-purple-200 p-20 mobile:p-6 max-w-full mobile:max-w-xs rounded-md flex justify-center items-center mx-auto">
      <div className="bg-purple-50 rounded-md shadow-sm py-4 px-3 flex flex-col items-center text-gray-500 w-full">
        <Text className="text-sm mobile:text-xs text-app-blue text-center">
          Click to open in new window
        </Text>
        <NavLink
          className="text-base mobile:text-sm text-black my-2 break-words text-center"
          target="_blank"
          to={href}
        >
          {href}
        </NavLink>
      </div>
    </div>

  );
};

export default MediaLink;
